import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const $Step$p = (_1, _2, _3, _4) => ({tag: "Step", _1, _2, _3, _4});
const Step = value0 => value1 => value2 => value3 => $Step$p(value0, value1, value2, value3);
const unStep = Unsafe$dCoerce.unsafeCoerce;
const step = (v, $0) => {
  const $1 = v._2;
  return v._3($1, $0);
};
const mkStep = Unsafe$dCoerce.unsafeCoerce;
const halt = v => {
  const $0 = v._2;
  return v._4($0);
};
const extract = v => v._1;
export {$Step$p, Step, extract, halt, mkStep, step, unStep};
